import React, { useState } from 'react';
import UserRank from './UserRank';
import RandomUserList from './RandomUserList';
import SearchUser from './SearchUser';

const OtherSun = ({ token , onClose }) => {
    const [activeComponent, setActiveComponent] = useState('userRank'); // 현재 표시 중인 컴포넌트

    // 각 버튼을 클릭하면 상태를 변경하여 컴포넌트를 전환
    const handleShowUserRank = () => setActiveComponent('userRank');
    const handleShowRandomUserList = () => setActiveComponent('randomUserList');
    const handleShowSearchUser = () => setActiveComponent('searchUser');

    // return (
    //         <div className="other-sun">
    //             <h3 className="other-sun-title">다른 사람의 해 찾아보기 </h3>

    //             {/* 버튼들 */}
    //             <div className="other-sun-buttons">
    //                 <button onClick={handleShowUserRank} className="other-sun-button">
    //                     해돋이 명소 순위 보기
    //                 </button>
    //                 <button onClick={handleShowRandomUserList} className="other-sun-button">
    //                     해돋이 명소 추천 받기
    //                 </button>
    //                 <button onClick={handleShowSearchUser} className="other-sun-button">
    //                     해돋이 명소 검색하기
    //                 </button>
    //             </div>

    //             {/* 표시할 컴포넌트 */}
    //             <div className="other-sun-content">
    //                 {activeComponent === 'userRank' && <UserRank token={token} />}
    //                 {activeComponent === 'randomUserList' && <RandomUserList token={token} />}
    //                 {activeComponent === 'searchUser' && <SearchUser token={token} />}
    //             </div>
    //         </div>
    // );

    return (
        <div className="other-sun">
          <h3 className="other-sun-title">다른 사람의 해 찾아보기</h3>
      
          {/* 버튼들 */}
          <div className="other-sun-buttons">
            <button onClick={handleShowUserRank} className="other-sun-button">
              <span className="emoji-button">👑</span>
              <span className="button-text">해돋이 명소 순위 보기</span>
            </button>
            <button onClick={handleShowRandomUserList} className="other-sun-button">
              <span className="emoji-button">❓</span>
              <span className="button-text">해돋이 명소 추천 받기</span>
            </button>
            <button onClick={handleShowSearchUser} className="other-sun-button">
              <span className="emoji-button">🔎</span>
              <span className="button-text">해돋이 명소 검색하기</span>
            </button>
          </div>
      
          {/* 표시할 컴포넌트 */}
          <div className="other-sun-content">
            {activeComponent === 'userRank' && <UserRank token={token} onClose={onClose}/>}
            {activeComponent === 'randomUserList' && <RandomUserList token={token} onClose={onClose}/>}
            {activeComponent === 'searchUser' && <SearchUser token={token} onClose={onClose}/>}
          </div>
        </div>
      );
};

export default OtherSun;
